import type { Messages } from './en';

export const ru: Messages = {
  'nav.clientHub': 'Портал клиента',
  'nav.menu': 'Меню',
  'nav.home': 'Главная',
  'nav.products': 'Продукты',
  'nav.liveCasino': 'Live Casino',
  'nav.slots': 'Слоты',
  'nav.tableGames': 'Настольные игры',
  'nav.library': 'Библиотека',
  'nav.roadmap': 'Дорожная карта',
  'nav.assets': 'Материалы',
  'nav.guidelines': 'Руководства',
  'nav.account': 'Аккаунт',
  'nav.signOut': 'Выйти',
  'nav.categoriesAria': 'Категории игр',
  'nav.sectionsAria': 'Основные разделы',
  'nav.brandAria': 'RichyPlay Портал клиента',
  'nav.comingSoon': 'Скоро',
  'nav.soon': 'Скоро',

  'lang.label': 'Язык',
  'lang.select': 'Выбрать язык',

  'category.live': 'Лайв',
  'category.slot': 'Слоты',
  'category.instant': 'Мгновенные',
  'category.table': 'Столы',

  'status.planned': 'Запланировано',
  'status.in_progress': 'В работе',
  'status.shipped': 'Выпущено',
  'status.available': 'Доступно',
  'status.coming_soon': 'Скоро',
  'status.maintenance': 'Обслуживание',

  'common.error': 'Что-то пошло не так',
  'common.checkingSession': 'Проверка сессии…',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.none': 'Нет',
  'common.active': 'Активно',
  'common.inactive': 'Неактивно',

  'home.eyebrow': 'Портал оператора',
  'home.title': 'Портал клиента',
  'home.lead':
    'Изучайте портфолио RichyPlay — запускайте демоверсии, следите за дорожной картой и загружайте брендовые материалы в одном рабочем пространстве.',
  'home.enterLibrary': 'Открыть библиотеку',
  'home.viewRoadmap': 'Дорожная карта',
  'home.browse': 'Просмотр по категориям',
  'home.openLibrary': 'Открыть библиотеку',

  'library.eyebrow': 'Библиотека игр',
  'library.title': 'Портфолио',
  'library.liveTitle': 'Портфолио Live Casino',
  'library.slotTitle': 'Портфолио слотов',
  'library.liveLead': 'Выберите live-продукт. Blackjack и Roulette уже доступны; остальные скоро.',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead': 'Ищите и фильтруйте каталог RichyPlay. Демоверсии открываются в новой вкладке.',
  'library.search': 'Поиск игр…',
  'library.statusFilterAria': 'Фильтр по статусу',
  'library.statusAll': 'Все статусы',
  'library.loading': 'Загрузка игр…',
  'library.unavailableTitle': 'Библиотека недоступна',
  'library.unavailableMessage': 'Не удалось загрузить библиотеку игр. Каталог может быть недоступен.',
  'library.apiFailedMessage':
    'Не удалось связаться с API каталога. Повторите попытку позже или обратитесь в поддержку.',
  'library.emptyTitle': 'Игры не найдены',
  'library.emptyMessage': 'Попробуйте изменить поисковый запрос или фильтр категории.',
  'library.viewGame': 'Открыть игру',

  'game.loading': 'Загрузка игры…',
  'game.notFound': 'Игра не найдена.',
  'game.back': 'Назад',
  'game.breadcrumbAria': 'Навигационная цепочка',
  'game.liveCasino': 'Лайв-казино',
  'game.slots': 'Слоты',
  'game.demoFrameTitle': 'Демо {title}',
  'game.startingDemo': 'Запуск демосессии…',
  'game.demoNotStarted': 'Не удалось запустить демосессию.',
  'game.demoBadge': 'Деморежим',
  'game.blockedMaintenance': 'Игра находится на техническом обслуживании.',
  'game.blockedComingSoon': 'Скоро — демоверсия ещё не опубликована.',
  'game.blockedNoDemo': 'В каталоге оператора нет демоверсии для этой игры.',
  'game.currency': 'Валюта',
  'game.language': 'Язык',
  'game.reloadDemo': 'Перезапустить демо',
  'game.startDemo': 'Запустить демо',
  'game.openNewTab': 'Открыть в новой вкладке',
  'game.copyLink': 'Копировать ссылку',
  'game.copied': 'Скопировано',
  'game.demoFailedTitle': 'Не удалось запустить демо',
  'game.demoUrlMissing': 'Сервер не вернул ссылку для запуска.',
  'game.demoFailed': 'Не удалось запустить демоверсию.',
  'game.highlighted': 'Рекомендуемая',
  'game.features': 'Особенности игры',
  'game.keyFeatures': 'Ключевые особенности',
  'liveTable.title': 'Доступные столы',
  'liveTable.totalResults': 'Всего результатов:',
  'liveTable.download': 'Скачать данные столов',
  'liveTable.gameId': 'ID игры',
  'liveTable.tableName': 'Название стола',
  'liveTable.minLimit': 'Мин. лимит стола',
  'liveTable.maxLimit': 'Макс. лимит стола',
  'liveTable.hours': 'Часы работы UTC',
  'liveTable.language': 'Язык стола',
  'liveTable.releaseDate': 'Дата выпуска',
  'liveTable.location': 'Локация',
  'game.betLevels': 'Уровни ставок',
  'game.tableRules': 'Правила стола',
  'game.mathConfig': 'Математическая конфигурация',
  'game.resources': 'Материалы',
  'game.relatedAssets': 'Связанные материалы',
  'game.releaseRoadmap': 'Дорожная карта релизов',
  'game.integrationGuidelines': 'Руководства по интеграции',
  'game.information': 'Информация об игре',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'Компьютер',
  'game.platformTablet': 'Планшет',
  'game.platformMobile': 'Телефон',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'Таблица данных игры будет добавлена позже.',

  'spec.numericId': 'Числовой ID',
  'spec.minBetPerLine': 'Мин. ставка на линию',
  'spec.minTotalBet': 'Мин. общая ставка',
  'spec.maxTotalBet': 'Макс. общая ставка',
  'spec.maxTotalBetAnte': 'Макс. общая ставка с Ante',
  'spec.reels': 'Барабаны',
  'spec.rows': 'Ряды',
  'spec.payType': 'Тип выплат',
  'spec.payLinesValue': '{count} линий',
  'spec.symbolPays': 'Выплаты за символы',
  'spec.betMultiplier': 'Множитель ставки',
  'spec.maxMultiplierWin': 'Макс. выигрыш множителя',
  'spec.maxExposure': 'Максимальный риск',
  'spec.bonusBuyX': 'Покупка бонуса X',
  'spec.anteBetX': 'Ставка Ante X',
  'spec.rtps': 'RTP',
  'spec.hitFrequency': 'Частота выигрышей',
  'spec.oneIn': '1 из {value}',
  'spec.hasReplay': 'Реплей',
  'spec.hasBuySpins': 'Покупка спинов',
  'spec.hasInstantBonus': 'Мгновенный бонус',
  'spec.hasHyperplay': 'Hyperplay',
  'spec.hasAnteBet': 'Ставка Ante',
  'spec.releaseDate': 'Дата выпуска',
  'spec.symbol': 'Символ игры',
  'spec.referenceId': 'Референсный ID',
  'spec.provider': 'Провайдер',
  'spec.product': 'Продукт',
  'spec.gameType': 'Тип игры',
  'spec.category': 'Категория',
  'spec.theme': 'Тема',
  'spec.technology': 'Технология',
  'spec.rtp': 'RTP',
  'spec.volatility': 'Волатильность',
  'spec.maxWin': 'Макс. выигрыш',
  'spec.paylines': 'Линии выплат',
  'spec.grid': 'Сетка',
  'spec.bonusFrequency': 'Частота бонусов',
  'spec.bonusFrequencyValue': '1 из {value}',
  'spec.jackpot': 'Джекпот',
  'spec.betRange': 'Диапазон ставок',
  'spec.defaultBet': 'Ставка по умолчанию',
  'spec.currency': 'Валюта',
  'spec.languages': 'Языки',
  'spec.demoAvailable': 'Демо доступно',
  'spec.tournaments': 'Турниры',
  'spec.highlighted': 'Рекомендуемая',
  'spec.status': 'Статус',
  'spec.version': 'Версия',
  'spec.lastUpdated': 'Последнее обновление',

  'roadmap.eyebrow': 'Дорожная карта продукта',
  'roadmap.title': 'Что дальше',
  'roadmap.lead': 'Следите за предстоящими релизами и выпущенными играми по категориям.',
  'roadmap.bannerAria': 'Предстоящие релизы',
  'roadmap.soonTitle': 'Скоро',
  'roadmap.loading': 'Загрузка дорожной карты…',
  'roadmap.error': 'Не удалось загрузить элементы дорожной карты.',
  'roadmap.emptyTitle': 'Нет элементов',
  'roadmap.emptyMessage': 'Для этой категории пока нет опубликованных записей.',
  'roadmap.itemCount': 'Элементов: {count}',
  'roadmap.target': 'Цель: {date}',
  'roadmap.viewInLibrary': 'Открыть в библиотеке',

  'upcoming.title': 'Ближайшие релизы',
  'upcoming.playDemo': 'Играть демо',
  'upcoming.prev': 'Предыдущие релизы',
  'upcoming.next': 'Следующие релизы',

  'assets.eyebrow': 'Брендовые материалы',
  'assets.title': 'Пакеты материалов',
  'assets.lead':
    'Загружайте логотипы, ключевые изображения и маркетинговые материалы. Правила использования смотрите в разделе {link}.',
  'assets.leadLink': 'руководства по материалам',
  'assets.loading': 'Загрузка материалов…',
  'assets.error': 'Не удалось загрузить пакеты материалов.',
  'assets.downloadFailed': 'Не удалось скачать файл.',
  'assets.emptyTitle': 'Материалов пока нет',
  'assets.emptyForGame': 'С этой игрой не связано ни одного пакета материалов.',
  'assets.emptyGeneral': 'Пакеты материалов появятся здесь после публикации.',
  'assets.pack': 'Пакет',
  'assets.updated': 'Обновлено {date}',
  'assets.download': 'Скачать',
  'assets.search': 'Поиск по названию игры…',
  'assets.searchEmpty': 'Игр с таким названием нет.',

  'guidelines.eyebrow': 'Документация',
  'guidelines.title': 'Руководства',
  'guidelines.lead': 'Заметки по интеграции, использование материалов и справочники для операторов.',
  'guidelines.all': 'Все',
  'guidelines.integration': 'Интеграция',
  'guidelines.assets': 'Материалы',
  'guidelines.loading': 'Загрузка руководств…',
  'guidelines.error': 'Не удалось загрузить руководства.',
  'guidelines.emptyTitle': 'Руководств нет',
  'guidelines.emptyMessage': 'Опубликованные руководства появятся здесь.',
  'guidelines.index': 'Содержание',
  'guidelines.navAria': 'Навигация по руководствам',
  'guidelines.articleLoading': 'Загрузка статьи…',
  'guidelines.notFound': 'Руководство не найдено.',
  'guidelines.notFoundShort': 'Не найдено',
  'guidelines.updated': 'Обновлено {date}',
  'guidelines.external': 'Содержимое размещено на внешнем ресурсе.',
  'guidelines.openDocument': 'Открыть документ',
  'guidelines.typeGuide': 'Гид',
  'guidelines.typeGuideline': 'Руководство',

  'account.eyebrow': 'Ваш аккаунт',
  'account.title': 'Профиль',
  'account.email': 'Эл. почта',
  'account.language': 'Язык интерфейса',
  'account.recentActivity': 'Недавняя активность',
  'account.loadingActivity': 'Загрузка активности…',
  'account.activityUnavailable': 'Недавняя активность сейчас недоступна.',
  'account.noActivity': 'Недавней активности не зафиксировано.',

  'event.login': 'Вход выполнен',
  'event.logout': 'Выход выполнен',
  'event.libraryView': 'Просмотр библиотеки',
  'event.gameView': 'Просмотр игры',
  'event.demoLaunch': 'Запуск демо',
  'event.demoLaunchFailed': 'Не удалось запустить демо',
  'event.assetDownload': 'Загрузка материала',
  'event.guidelineView': 'Просмотр руководства',
  'event.roadmapView': 'Просмотр дорожной карты',

  'auth.title': 'Портал клиента',
  'auth.subtitle': 'Войдите, используя учётные данные оператора',
  'auth.email': 'Эл. почта',
  'auth.password': 'Пароль',
  'auth.rememberMe': 'Запомнить меня',
  'auth.signIn': 'Войти',
  'auth.signInFailed': 'Не удалось войти',
  'auth.signInError': 'Не удалось войти. Проверьте учётные данные и попробуйте снова.',
  'auth.forgotPassword': 'Забыли пароль?',
  'auth.inviteOnly': 'Доступ только по приглашению. Обратитесь к представителю RichyPlay.',
  'auth.visitSiteAria': 'Перейти на richyplay.live',

  'footer.navAria': 'Нижний колонтитул',
  'footer.tagline': 'Портал операторов для каталога слотов и лайв-казино RichyPlay.',
  'footer.rights': 'Все права защищены.',
  'footer.legal':
    'Доступ по приглашению для лицензированных операторов. Только для делового использования.',

  'forgot.eyebrow': 'Сброс пароля',
  'forgot.title': 'Забыли пароль',
  'forgot.requestSubtitle':
    'Введите адрес эл. почты — если аккаунт существует, мы отправим код подтверждения.',
  'forgot.sendCode': 'Отправить код',
  'forgot.sendError': 'Не удалось отправить код сброса.',
  'forgot.confirmSubtitle': 'Введите код из письма и задайте новый пароль.',
  'forgot.code': 'Код подтверждения',
  'forgot.newPassword': 'Новый пароль',
  'forgot.update': 'Обновить пароль',
  'forgot.updateError': 'Не удалось сбросить пароль.',
  'forgot.doneSubtitle': 'Пароль обновлён. Теперь вы можете войти.',
  'forgot.backToSignIn': 'Вернуться ко входу',
};
